import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { fetchCountries } from '@/services/countriesService';

export const COUNTRIES_QUERY_KEY = ['countries'] as const;

type UseCountriesOptions = Pick<
  UseQueryOptions<Awaited<ReturnType<typeof fetchCountries>>>,
  'staleTime' | 'refetchOnMount'
>;

export function useCountries(filter?: { activeOnly?: boolean }, options?: UseCountriesOptions) {
  return useQuery({
    queryKey: [...COUNTRIES_QUERY_KEY, filter],
    queryFn: () => fetchCountries(filter),
    staleTime: 60 * 60 * 1000, // 1 hour — справочник меняется редко
    refetchOnWindowFocus: false,
    ...options,
  });
}
